import React from 'react';
import { translate } from '../Services/translation';

  const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
    const groupByCategory = (items) => {
      return items.reduce((acc, item) => {

        if (item.category === 'Brands') return acc;

        if (!acc[item.category]) {
          acc[item.category] = [];
        }
        acc[item.category].push(item);
        return acc;
      }, {});
    };
  
    const groupedResults = groupByCategory(result);
    const hasNoHit = result.some(item => item.category === 'NoHit');
    const isButton = result.some(item => item.category === 'ShowAll');

    return (
      <div 
        className={`quick-search-result ${hasNoHit ? 'no-hit' : ''}`}
      >
        {Object.keys(groupedResults).map((category) => (
          <ul key={category} className="quick-search-result__column-wrap">
            {category && category === 'NoHit' || category === "ShowAll" ? 
            "" : 
              <li className="quick-search-result__group-header">
                {category}
              </li>
            }
            <ul className='quick-search-result__group-list'>
            {groupedResults[category].map((item, index) => (
              <li
                key={`${item.name}-${index}`}
                className={`quick-search-result__item ${selectedItem === index ? 'quick-search-result__item--selected' : ''}`}
              >
                <a
                  className={item.showAll ? 
                    'quick-search-result__show-all' : `quick-search-result__link ${item.url ? 
                      '' : 'quick-search-result__link--disabled'}`}
                  href={item.showAll ? searchUrl : item.url}
                >
                  {item.hasImage && item.imageSource && (
                    <img className="quick-search-result__image" src={item.imageSource} />
                  )}
                  <div>
                  {item.category && item.category === 'NoHit' ? 
                    <div
                        className="no-hit-description"
                        dangerouslySetInnerHTML={{
                            __html: item.name,
                        }}
                    ></div> : 
                    item.name
                  }
                  </div>
                </a>
              </li>
            ))}
            </ul>
          </ul>
        ))}
        <div className='quick-search-result__button-wrapper'>
          {isButton &&
            <a
            className='button'
            href={searchUrl}
            >{translate('search.showall')}</a>
          }
        </div>
      </div>
    );
  };

export default QuickSearchResult;
